// yyyy-mm-dd 转 yyyy.mm.dd
export function ParseDate(date, type) {
  let year = date.getFullYear();
  let month = (date.getMonth() + 1).toString().padStart(2, "0");
  let day = date.getDate().toString().padStart(2, "0");
  const format = type || "-";
  if (format == ".") {
    return `${year}.${month}.${day}`;
  }
  return `${year}-${month}-${day}`;
}

// 表单重置
export function resetForm(refName) {
  if (this.$refs[refName]) {
    if (this.$refs[refName].resetFields) {
      this.$refs[refName].resetFields();
    } else {
      this.$refs[refName][0].resetFields();
    }
  }
}

/**
 * 构造树型结构数据  parentId 和 children 都有数据
 * @param {*} data 数据源
 */
export function buildTree(data) {
  const treeMap = {};
  const tree = [];
  //将每个节点的 ID 作为 key，并将节点本身作为 value
  data.forEach((node) => {
    treeMap[node.id] = node;
  });
  // 构建树形结构
  data.forEach((node) => {
    const parentId = node.parentId;
    // 能否找到父节点,存在则添加到children 数组中
    const parentNode = treeMap[parentId];
    if (parentNode) {
      if (!parentNode.children) {
        parentNode.children = [];
      }
      parentNode.children.push(node);
    } else {
      tree.push(node);
    }
  });
  return tree;
}

/**
 * 获取当前时间
 * @param timeStr 时分秒 字符串 格式为 xx:xx:xx
 */
export function getNowDateTime(timeStr) {
  let now = new Date();
  let year = now.getFullYear(); //得到年份
  let month = (now.getMonth() + 1).toString().padStart(2, "0"); //得到月份
  let day = now.getDate().toString().padStart(2, "0"); //得到日期

  if (timeStr != null) {
    return `${year}-${month}-${day} ${timeStr}`;
  }
  let hours = now.getHours().toString().padStart(2, "0"); // 得到小时;
  let minutes = now.getMinutes().toString().padStart(2, "0"); // 得到分钟;
  let seconds = now.getSeconds().toString().padStart(2, "0"); // 得到秒;
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

// 日期格式化
export function parseTime(time, pattern) {
  if (arguments.length === 0 || !time) {
    return null;
  }
  const format = pattern || "{y}-{m}-{d} {h}:{i}:{s}";
  let date;
  if (typeof time === "object") {
    date = time;
  } else {
    if (typeof time === "string" && /^[0-9]+$/.test(time)) {
      time = parseInt(time);
    } else if (typeof time === "string") {
      time = time
        .replace(new RegExp(/-/gm), "/")
        .replace("T", " ")
        .replace(new RegExp(/\.\d{3}/gm), "");
    }
    if (typeof time === "number" && time.toString().length === 10) {
      time = time * 1000;
    }
    date = new Date(time);
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay(),
  };
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    let value = formatObj[key];
    // Note: getDay() returns 0 on Sunday
    if (key === "a") {
      return ["日", "一", "二", "三", "四", "五", "六"][value];
    }
    if (result.length > 0 && value < 10) {
      value = "0" + value;
    }
    return value || 0;
  });
  return time_str;
}

/**
 * 输入字符转换整形和小数点
 *
 * @param {*} divisor 除数
 * @param {*} dividend 被除数
 * @returns
 */
export function changeInput(point, item, field) {
  if (point == 0) {
    item[field] = item[field] // 除了数字和小数点以外的字符替换为空字符串
      .replace(/^(0+)|[^\d]+/g, "");
  } else {
    item[field] = item[field] // 除了数字和小数点以外的字符替换为空字符串
      .replace(/[^\d.]/g, "")
      // 将字符串中连续出现的多个小数点替换为单个小数点
      .replace(/\.{2,}/g, ".")
      // 将字符串中的第一个小数点替换为 "#"
      .replace(".", "$#$")
      // 将字符串中的所有小数点删除
      .replace(/\./g, "")
      .replace("$#$", ".")
      // eslint-disable-next-line no-useless-escape
      // .replace(/^(\-)*(\d+)\.(\\d{0,"+point+"}).*$/, "$1$2.$3")
      .replace(new RegExp("^(-)*(\\d+)\\.(\\d{0," + point + "}).*$"), "$1$2.$3")
      //将字符串开头的小数点 "." 替换为空字符串
      .replace(/^\./g, "");
  }
}
/**
 * 时间戳转"yyyy-MM-dd HH:mm:ss
 * @param {*} timestamp 
 * @returns 
 */
export function formatTimestamp(timestamp) {
  const date = new Date(timestamp);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");

  const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  return formattedDate;
}

/**
 * 防抖函数
 * @param fn
 * @param delay
 * @returns {(function(): void)|*}
 */
export function debounce(fn, delay) {
  let timer = null;
  return function () {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      fn.apply(this, arguments);
    }, delay);
  };
}

/**
 * 节流函数
 * @param fn
 * @param delay
 * @returns {(function(): void)|*}
 */
export function throttle(fn, delay) {
  let lastTime = 0;
  return function () {
    let nowTime = Date.now();
    if (nowTime - lastTime > delay) {
      fn.apply(this, arguments);
      lastTime = nowTime;
    }
  };
}